import { render } from "./RehearsalStage.vue?vue&type=template&id=053b5b7b"
import script from "./RehearsalStage.vue?vue&type=script&lang=js"
export * from "./RehearsalStage.vue?vue&type=script&lang=js"
script.render = render

export default script